/*
 * サブシステム名：
 * 機能名：かんたん日報入力
 * 表示項目カスタマイズ(antz)
 */

import D2PRMD0040 from '@/views/PRM/D2PRMD0040.js'
import filter from '@/rahmen/utils/filters'
import d2fmt from '@/ddv2.library/utils/formatter'
import indexeddb from '@/ddv2.library/indexeddb'

export default ({
  extends: D2PRMD0040,
  name: 'NippoEasyEditCustomForAntz',
  data: () => ({
    customJuchuRirekiHeaders: [
      { text: '', value: 'actions', align: 'center' },
      { text: '受注営業所', value: 'juchuEigyoshoNm' },
      { text: '荷主', value: 'tokuisakiNm' },
      // { text: '注文番号', value: 'chumonNo' },
      { text: '発地', value: 'hatsuchiDisp' },
      { text: '着地', value: 'chakuchiDisp' },
      { text: '発地年月日', value: 'hatsuchiYmdDisp' },
      { text: '発地時刻', value: 'hatsuchiHmsDisp' },
      { text: '着地', value: 'chakuchiDisp' },
      { text: '着地年月日', value: 'chakuchiYmdDisp' },
      { text: '着地時刻', value: 'chakuchiHmsDisp' },
      { text: '走行距離', value: 'yoteiSokoKyoriDisp' },
      { text: '現場名', value: 'hinmeiDisp' },
      { text: '数量', value: 'juchuSuryoDisp', align: 'end' },
      { text: '単位', value: 'unitKbnNm' },
      { text: '重量(t)', value: 'juchuJuryoDisp', align: 'end' },
      { text: '単価', value: 'tankaDisp' },
      { text: '請求計上日', value: 'seikyuYoteiYmdDisp' },
      { text: '運賃計算区分', value: 'unchinKeisanKbnNm' },
      { text: '請求車種', value: 'seikyuShashuSbtNm' },
      { text: '運賃', value: 'kihonUnchinDisp', align: 'end' },
      { text: '高速代', value: 'hiwayPriceDisp', align: 'end' },
      { text: 'その他課税', value: 'unchinHokaKingakuDisp', align: 'end' },
      { text: 'その他非課税', value: 'unchinHokaHikazeiDisp', align: 'end' },
      { text: '売上金額', value: 'uriageKingakuDisp', align: 'end' },
      { text: '待機時間', value: 'taikiJikanDisp', align: 'center' },
      { text: '待機時間単価', value: 'taikiJikanTankaDisp', align: 'end' },
      { text: '待機時間料', value: 'taikiJikanKingakuDisp', align: 'end' },
      { text: '割増金額(時間)', value: 'jikanWarimashiKingakuDisp', align: 'end' },
      { text: '割増金額(距離)', value: 'kyoriWarimashiKingakuDisp', align: 'end' },
      { text: '割増その他', value: 'warimashiSonotaKingakuDisp', align: 'end' },
      { text: '傭車額', value: 'yoshaKihonUnchinDisp', align: 'end' },
      { text: '傭車高速代', value: 'yoshaHiwayPriceDisp', align: 'end' },
      { text: '傭車その他課税', value: 'yoshaUnchinHokaKingakuDisp', align: 'end' },
      { text: '傭車その他非課税', value: 'yoshaUnchinHokaHikazeiDisp', align: 'end' },
      { text: '請求用備考', value: 'seikyuBiko' },
      { text: '連絡用備考', value: 'renrakuBiko' }
    ],
    customTeikeiCorseHeaders: [
      { text: '', value: 'actions', align: 'center' },
      { text: 'コースNo', value: 'teikeiCourseNo' },
      { text: 'コース名称', value: 'teikeiCourseNm' },
      { text: '荷主', value: 'tokuisakiNm' },
      { text: '発地', value: 'hatsuchiDisp' },
      { text: '発時刻', value: 'hatsuchiHmsDisp' },
      { text: '着地', value: 'chakuchiDisp' },
      { text: '着時刻', value: 'chakuchiHmsDisp' },
      { text: '走行距離', value: 'yoteiSokoKyoriDisp' },
      { text: '請求車種', value: 'seikyuShashuSbtNm' },
      { text: '運賃計算方法', value: 'unchinKeisanKbnNm' },
      { text: '数量', value: 'juchuSuryo', align: 'end' },
      { text: '単位', value: 'unitKbnNm' },
      { text: '重量', value: 'juchuJuryo', align: 'end' },
      { text: '単価', value: 'tanka', align: 'end' },
      { text: '運賃', value: 'kihonUnchin', align: 'end' },
      { text: '高速代', value: 'hiwayPrice', align: 'end' },
      { text: 'その他課税', value: 'unchinHokaKingaku', align: 'end' },
      { text: 'その他非課税', value: 'unchinHokaHikazei', align: 'end' },
      { text: '待機時間', value: 'taikiJikanDisp', align: 'center' },
      { text: '待機時間単価', value: 'taikiJikanTanka', align: 'end' },
      { text: '待機時間料', value: 'taikiJikanKingaku', align: 'end' },
      { text: '時間割増金額', value: 'jikanWarimashiKingaku', align: 'end' },
      { text: '距離割増金額', value: 'kyoriWarimashiKingaku', align: 'end' },
      { text: '割増その他', value: 'warimashiSonotaKingaku', align: 'end' },
      { text: '請求金額合計', value: 'seikyuGokei', align: 'end' },
      { text: '売上金額', value: 'uriageKingaku', align: 'end' },
      { text: '請求用備考', value: 'seikyuBiko' },
      { text: '連絡用備考', value: 'renrakuBiko' },
      { text: '支払運賃', value: 'yoshaUnchin', align: 'end' },
      { text: '支払運賃(高速)', value: 'yoshaHiwayPrice', align: 'end' },
      { text: '支払その他課税', value: 'yoshaUnchinHokaKingaku', align: 'end' },
      { text: '支払その他非課税', value: 'yoshaUnchinHokaHikazei', align: 'end' },
      { text: '支払金額合計', value: 'shiharaiGokei', align: 'end' },
      { text: '支払用備考', value: 'shiharaiBiko' }
    ]
  }),
  computed: {
    isDeleteButtonDisplay () {
      if (this.modeKengen === 2 && this.modeOfEdit === 2 && !this.kakuninzumiMode && !this.seikyuZumiMode && !this.shiharaiZumiMode && this.id > 0) {
        return true
      }
      return false
    },
    isCopyButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit === 2 && this.id > 0) {
        return true
      }
      return false
    },
    // 定型コースフィルター --> ここから
    customFilteredTeikeiCourseList () {
      return this.teikeiCourseList.map((elem) => {
        if (elem.tokuisakiId) { elem.tokuisakiDisp = elem.tokuisakiNm }
        elem.hinmeiDisp = elem.mstHinmeiId ? elem.hinmeiNm : elem.hinmeiBiko
        elem.hatsuchiDisp = elem.hatsuchiId ? elem.hatsuchiNm : elem.hatsuchiBiko
        elem.chakuchiDisp = elem.chakuchiId ? elem.chakuchiNm : elem.chakuchiBiko
        elem.keiyuchiId1Disp = elem.keiyuchiId1 ? elem.keiyuchiId1Nm : elem.keiyuchiId1Biko
        if (elem.tantoEigyoshoId) { elem.tantoEigyoshoDisp = elem.tantoEigyoshoCd + ' : ' + elem.tantoEigyoshoNm }
        elem.hatsuchiHmsDisp = elem.hatsuchiHms ? (elem.hatsuchiHms).slice(0, 5) : elem.hatsuchiHmsBiko
        elem.chakuchiHmsDisp = elem.chakuchiHms ? (elem.chakuchiHms).slice(0, 5) : elem.chakuchiHmsBiko
        elem.yoteiSokoKyoriDisp = elem.yoteiSokoKyori ? filter.numericFormatter(elem.yoteiSokoKyori) + ' km' : null
        if (elem.juchuSuryo) { elem.juchuSuryo = filter.numericFormatter(elem.juchuSuryo) }
        if (elem.juchuJuryo) { elem.juchuJuryo = filter.numericFormatter(elem.juchuJuryo) }
        if (elem.tanka) { elem.tanka = filter.numericFormatter(elem.tanka) }
        if (elem.kihonUnchin) { elem.kihonUnchin = filter.numericFormatter(elem.kihonUnchin) }
        if (elem.hiwayPrice) { elem.hiwayPrice = filter.numericFormatter(elem.hiwayPrice) }
        if (elem.unchinHokaKingaku) { elem.unchinHokaKingaku = filter.numericFormatter(elem.unchinHokaKingaku) }
        if (elem.unchinHokaHikazei) { elem.unchinHokaHikazei = filter.numericFormatter(elem.unchinHokaHikazei) }
        if (elem.nenryoSurcharge) { elem.nenryoSurcharge = filter.numericFormatter(elem.nenryoSurcharge) }
        if (elem.tsumikomiKingaku) { elem.tsumikomiKingaku = filter.numericFormatter(elem.tsumikomiKingaku) }
        if (elem.torioroshiKingaku) { elem.torioroshiKingaku = filter.numericFormatter(elem.torioroshiKingaku) }
        elem.taikiJikanDisp = elem.taikiJikan ? filter.minToIntervalTimeFormatter(elem.taikiJikan) : null
        if (elem.taikiJikanTanka) { elem.taikiJikanTanka = filter.numericFormatter(elem.taikiJikanTanka) }
        if (elem.taikiJikanKingaku) { elem.taikiJikanKingaku = filter.numericFormatter(elem.taikiJikanKingaku) }
        if (elem.futaiGyomuKingaku) { elem.futaiGyomuKingaku = filter.numericFormatter(elem.futaiGyomuKingaku) }
        if (elem.jikanWarimashiKingaku) { elem.jikanWarimashiKingaku = filter.numericFormatter(elem.jikanWarimashiKingaku) }
        if (elem.kyoriWarimashiKingaku) { elem.kyoriWarimashiKingaku = filter.numericFormatter(elem.kyoriWarimashiKingaku) }
        if (elem.warimashiSonotaKingaku) { elem.warimashiSonotaKingaku = filter.numericFormatter(elem.warimashiSonotaKingaku) }
        if (elem.seikyuGokei) { elem.seikyuGokei = filter.numericFormatter(elem.seikyuGokei) }
        if (elem.uriageKingaku) { elem.uriageKingaku = filter.numericFormatter(elem.uriageKingaku) }
        if (elem.yoshaUnchin) { elem.yoshaUnchin = filter.numericFormatter(elem.yoshaUnchin) }
        if (elem.yoshaHiwayPrice) { elem.yoshaHiwayPrice = filter.numericFormatter(elem.yoshaHiwayPrice) }
        if (elem.yoshaUnchinHokaKingaku) { elem.yoshaUnchinHokaKingaku = filter.numericFormatter(elem.yoshaUnchinHokaKingaku) }
        if (elem.yoshaUnchinHokaHikazei) { elem.yoshaUnchinHokaHikazei = filter.numericFormatter(elem.yoshaUnchinHokaHikazei) }
        if (elem.shiharaiGokei) { elem.shiharaiGokei = filter.numericFormatter(elem.shiharaiGokei) }
        return elem
      }).sort((a, b) => {
        if (a.teikeiCourseNo < b.teikeiCourseNo) { return -1 }
        if (a.teikeiCourseNo > b.teikeiCourseNo) { return 1 }
        return 0
      })
    }
    // 定型コースフィルター <-- ここまで
  },
  methods: {
    calcTaikiJikanKingaku: function () {
      let taikiJikan = this.recHaisoMeisai.taikiJikan
      let taikiJikanTanka = this.recHaisoMeisai.taikiJikanTanka

      if (taikiJikan === undefined || taikiJikan === '' || taikiJikan === null) { taikiJikan = '00:00' }
      if (taikiJikanTanka === undefined || taikiJikanTanka === '' || taikiJikanTanka === null) { taikiJikanTanka = 0 }

      taikiJikan = filter.timeToMinFormatter(taikiJikan)

      const taikiJikanKingaku = this.calcFraction((taikiJikan / 60) * taikiJikanTanka)
      this.$set(this.recHaisoMeisai, 'taikiJikanKingaku', taikiJikanKingaku)
      this.calcUriageKingakuAmount()
    },
    calcUriageKingakuAmount: function () {
      let amount = 0
      // const hasuKeisanKbn = this.recTokuisakiInfo.unchinHasuKeisanKbn ? this.recTokuisakiInfo.unchinHasuKeisanKbn : '02'
      amount += parseInt(this.calcUnchin, 10)
      if (this.recHaisoMeisai.hiwayPrice) { amount += parseFloat(this.recHaisoMeisai.hiwayPrice, 10) }
      if (this.recHaisoMeisai.unchinHokaKingaku) { amount += parseFloat(this.recHaisoMeisai.unchinHokaKingaku, 10) }
      if (this.recHaisoMeisai.unchinHokaHikazei) { amount += parseFloat(this.recHaisoMeisai.unchinHokaHikazei, 10) }
      if (this.recHaisoMeisai.taikiJikanKingaku) { amount += parseFloat(this.recHaisoMeisai.taikiJikanKingaku, 10) }

      this.$set(this.recHaisoMeisai, 'uriageKingaku', amount)
    },
    registerPromise: function () {
      this.convertToDBType()
      const self = this
      // 運行実績の出庫帰庫と勤怠の出庫帰庫を分けて登録する場合は、sharyoJininTimeSeparateModeを'1'に設定する。
      this.viewsData.sharyoJininTimeSeparateMode = 1
      if (this.viewsData.vwUnkoJisseki.haishaKbn === '02' && ![undefined, null, ''].includes(this.jishaSharyoSbt)) {
        console.log('seikyuShashuSbt update in registerPromise')
        this.viewsData.vwHaisoMeisai.filter((elem) => {
          return [undefined, null, ''].includes(elem.seikyuShashuSbt)
        }).map((elem) => {
          elem.seikyuShashuSbt = self.jishaSharyoSbt
          return elem
        })
      }
      const f = this.HttpClient.post('/api/v1/D2PRMD0020/JuchuWithJissekiCreateSeikyuUriageSeparate', this.viewsData)
      return f
    },
    selectJuchuRirekiInfo: function (e) {
      console.log(e)
      if (!e) { return }
      let initHaisoMeisai = Object.assign({}, this.recHaisoMeisai)

      initHaisoMeisai = {
        ...initHaisoMeisai,
        teikeiKihonNo: e.teikeiKihonNo,
        chumonNo: e.chumonNo,
        tokuisakiId: e.tokuisakiId,
        mstHinmeiId: e.mstHinmeiId,
        hinmeiBiko: e.hinmeiBiko,
        hatsuchiId: e.hatsuchiId,
        hatsuchiBiko: e.hatsuchiBiko,
        hatsuchiHms: e.hatsuchiHms ? e.hatsuchiHmsDisp : null,
        hatsuchiHmsBiko: e.hatsuchiHmsBiko,
        keiyuchiId1: e.keiyuchiId1,
        keiyuchiBiko1: e.keiyuchiBiko1,
        chakuchiId: e.chakuchiId,
        chakuchiBiko: e.chakuchiBiko,
        chakuchiHms: e.chakuchiHms ? e.chakuchiHmsDisp : null,
        chakuchiHmsBiko: e.chakuchiHmsBiko,
        yoteiSokoKyori: e.yoteiSokoKyori,
        unchinKeisanKbn: e.unchinKeisanKbn,
        seikyuShashuSbt: e.seikyuShashuSbt,
        juchuSuryo: e.juchuSuryo,
        unitKbn: ![undefined, null, ''].includes(e.unitKbn) ? e.unitKbn : null,
        juchuJuryo: e.juchuJuryo,
        tanka: e.tanka,
        hiwayPrice: e.hiwayPrice,
        unchinHokaKingaku: d2fmt.removeComma(e.unchinHokaKingaku),
        unchinHokaHikazei: d2fmt.removeComma(e.unchinHokaHikazei),
        nenryoSurcharge: e.nenryoSurcharge,
        tsumikomiKingaku: e.tsumikomiKingaku,
        torioroshiKingaku: e.torioroshiKingaku,
        taikiJikan: e.taikiJikanDisp,
        taikiJikanTanka: e.taikiJikanTanka,
        taikiJikanKingaku: e.taikiJikanKingaku,
        futaiGyomuKingaku: e.futaiGyomuKingaku,
        jikanWarimashiKingaku: d2fmt.removeComma(e.jikanWarimashiKingaku),
        kyoriWarimashiKingaku: d2fmt.removeComma(e.unchinHokaHikazei),
        warimashiSonotaKingsku: d2fmt.removeComma(e.warimashiSonotaKingaku),
        uriageKingaku: d2fmt.removeComma(e.uriageKingaku),
        seikyuBiko: e.seikyuBiko,
        renrakuBiko: e.renrakuBiko,
        yoshaKihonUnchin: this.viewsData.vwUnkoJisseki.haishaKbn === '03' ? e.yoshaKihonUnchin : null,
        yoshaHiwayPrice: this.viewsData.vwUnkoJisseki.haishaKbn === '03' ? e.yoshaHiwayPrice : null,
        yoshaUnchinHokaKingaku: this.viewsData.vwUnkoJisseki.haishaKbn === '03' ? d2fmt.removeComma(e.yoshaUnchinHokaKingaku) : null,
        yoshaUnchinHokaHikazei: this.viewsData.vwUnkoJisseki.haishaKbn === '03' ? d2fmt.removeComma(e.yoshaUnchinHokaHikazei) : null,
        shiharaiBiko: e.shiharaiBiko
      }

      // 金額項目チェック
      if (![undefined, null, 0].includes(initHaisoMeisai.unchinHokaKingaku) ||
          ![undefined, null, 0].includes(initHaisoMeisai.unchinHokaHikazei) ||
          ![undefined, null, 0].includes(initHaisoMeisai.jikanWarimashiKingaku) ||
          ![undefined, null, 0].includes(initHaisoMeisai.kyoriWarimashiKingaku) ||
          ![undefined, null, 0].includes(initHaisoMeisai.warimashiSonotaKingsku) ||
          ![undefined, null, 0].includes(initHaisoMeisai.unchinHokaKingaku)) {
        initHaisoMeisai.isHasEasyEditSeikyuKingaku = true
      } else {
        initHaisoMeisai.isHasEasyEditSeikyuKingaku = false
      }
      if (![undefined, null, 0].includes(initHaisoMeisai.yoshaUnchinHokaKingaku) ||
          ![undefined, null, 0].includes(initHaisoMeisai.yoshaUnchinHokaHikazei)) {
        initHaisoMeisai.isHasEasyEditShiharaiKingaku = true
      } else {
        initHaisoMeisai.isHasEasyEditShiharaiKingaku = false
      }

      this.setInitHaisoMeisai(initHaisoMeisai)
      initHaisoMeisai = undefined
    },
    // ポップアップから選択時
    teikeiCourseNoDialogSync: function (elem) {
      let initHaisoMeisai = Object.assign({}, this.recHaisoMeisai)

      initHaisoMeisai = {
        ...initHaisoMeisai,
        teikeiKihonNo: elem.teikeiKihonNo,
        chumonNo: elem.chumonNo,
        tokuisakiId: elem.tokuisakiId,
        mstHinmeiId: elem.mstHinmeiId,
        hinmeiBiko: elem.hinmeiBiko,
        hatsuchiId: elem.hatsuchiId,
        hatsuchiBiko: elem.hatsuchiBiko,
        hatsuchiHms: elem.hatsuchiHms ? (elem.hatsuchiHms).slice(0, 5) : null,
        hatsuchiHmsBiko: elem.hatsuchiHmsBiko,
        keiyuchiId1: elem.keiyuchiId1,
        keiyuchiBiko1: elem.keiyuchiId1Biko,
        chakuchiId: elem.chakuchiId,
        chakuchiBiko: elem.chakuchiBiko,
        chakuchiHms: elem.chakuchiHms ? (elem.chakuchiHms).slice(0, 5) : null,
        chakuchiHmsBiko: elem.chakuchiHmsBiko,
        yoteiSokoKyori: d2fmt.removeComma(elem.yoteiSokoKyori),
        unchinKeisanKbn: elem.unchinKeisanKbn,
        seikyuShashuSbt: elem.seikyuShashuSbt,
        juchuSuryo: d2fmt.removeComma(elem.juchuSuryo),
        unitKbn: ![undefined, null, ''].includes(elem.unitKbn) ? elem.unitKbn : null,
        juchuJuryo: d2fmt.removeComma(elem.juchuJuryo),
        tanka: d2fmt.removeComma(elem.tanka),
        hiwayPrice: d2fmt.removeComma(elem.hiwayPrice),
        unchinHokaKingaku: d2fmt.removeComma(elem.unchinHokaKingaku),
        unchinHokaHikazei: d2fmt.removeComma(elem.unchinHokaHikazei),
        nenryoSurcharge: d2fmt.removeComma(elem.nenryoSurcharge),
        tsumikomiKingaku: d2fmt.removeComma(elem.tsumikomiKingaku),
        torioroshiKingaku: d2fmt.removeComma(elem.torioroshiKingaku),
        taikiJikan: elem.taikiJikanDisp,
        taikiJikanTanka: d2fmt.removeComma(elem.taikiJikanTanka),
        taikiJikanKingaku: d2fmt.removeComma(elem.taikiJikanKingaku),
        futaiGyomuKingaku: d2fmt.removeComma(elem.futaiGyomuKingaku),
        jikanWarimashiKingaku: d2fmt.removeComma(elem.jikanWarimashiKingaku),
        kyoriWarimashiKingaku: d2fmt.removeComma(elem.unchinHokaHikazei),
        warimashiSonotaKingsku: d2fmt.removeComma(elem.warimashiSonotaKingaku),
        uriageKingaku: d2fmt.removeComma(elem.uriageKingaku),
        seikyuBiko: elem.seikyuBiko,
        renrakuBiko: elem.renrakuBiko,
        yoshaKihonUnchin: this.viewsData.vwUnkoJisseki.haishaKbn === '03' ? d2fmt.removeComma(elem.yoshaUnchin) : null,
        yoshaHiwayPrice: this.viewsData.vwUnkoJisseki.haishaKbn === '03' ? d2fmt.removeComma(elem.yoshaHiwayPrice) : null,
        yoshaUnchinHokaKingaku: this.viewsData.vwUnkoJisseki.haishaKbn === '03' ? d2fmt.removeComma(elem.yoshaUnchinHokaKingaku) : null,
        yoshaUnchinHokaHikazei: this.viewsData.vwUnkoJisseki.haishaKbn === '03' ? d2fmt.removeComma(elem.yoshaUnchinHokaHikazei) : null,
        shiharaiBiko: this.viewsData.vwUnkoJisseki.haishaKbn === '03' ? elem.shiharaiBiko : null
      }

      // 金額項目チェック
      if (![undefined, null, 0].includes(initHaisoMeisai.unchinHokaKingaku) ||
          ![undefined, null, 0].includes(initHaisoMeisai.unchinHokaHikazei) ||
          ![undefined, null, 0].includes(initHaisoMeisai.jikanWarimashiKingaku) ||
          ![undefined, null, 0].includes(initHaisoMeisai.kyoriWarimashiKingaku) ||
          ![undefined, null, 0].includes(initHaisoMeisai.warimashiSonotaKingsku) ||
          ![undefined, null, 0].includes(initHaisoMeisai.unchinHokaKingaku)) {
        initHaisoMeisai.isHasEasyEditSeikyuKingaku = true
      } else {
        initHaisoMeisai.isHasEasyEditSeikyuKingaku = false
      }
      if (![undefined, null, 0].includes(initHaisoMeisai.yoshaUnchinHokaKingaku) ||
          ![undefined, null, 0].includes(initHaisoMeisai.yoshaUnchinHokaHikazei)) {
        initHaisoMeisai.isHasEasyEditShiharaiKingaku = true
      } else {
        initHaisoMeisai.isHasEasyEditShiharaiKingaku = false
      }

      this.setInitHaisoMeisai(initHaisoMeisai)
      initHaisoMeisai = undefined
    },
    onUnkoYmdInput: function () {
      const self = this
      const unkoYmd = self.viewsData.vwUnkoJisseki.unkoYmd
      let tmpHaisoMeisai = Object.assign({}, this.recHaisoMeisai)
      tmpHaisoMeisai = {
        ...tmpHaisoMeisai,
        seikyuYoteiYmd: unkoYmd,
        shiharaiYoteiYmd: unkoYmd
      }
      self.recHaisoMeisai = Object.assign({}, tmpHaisoMeisai)
      if (self.viewsData.vwHaisoMeisai && self.viewsData.vwHaisoMeisai.length > 0) {
        // 配送明細の請求予定日と支払予定日を更新
        self.viewsData.vwHaisoMeisai = self.viewsData.vwHaisoMeisai.map((elem) => {
          elem.seikyuYoteiYmd = unkoYmd
          elem.shiharaiYoteiYmd = unkoYmd
          return elem
        })
        self.viewsData.vwHaisoMeisai.splice()
      }
    },
    changeCarInfo: function () {
      if (this.viewsData.vwUnkoJisseki.haishaKbn !== '03') {
        if (!this.viewsData.vwUnkoJisseki.sharyoId) { return }
        console.log('changeCarInfo')
        this.jishaSharyoSbt = indexeddb.getRecord(this.sharyoList, this.viewsData.vwUnkoJisseki.sharyoId).shashuSbt
        this.recHaisoMeisai.seikyuShashuSbt = this.jishaSharyoSbt
        if (this.viewsData.vwHaisoMeisai && this.viewsData.vwHaisoMeisai.length > 0) {
          this.viewsData.vwHaisoMeisai = this.viewsData.vwHaisoMeisai.map((elem) => {
            elem.seikyuShashuSbt = this.jishaSharyoSbt
            return elem
          })
          this.viewsData.vwHaisoMeisai.splice()
        }
      } else {
        if (!this.viewsData.vwUnkoJisseki.sharyoId) { return }
        this.viewsData.vwUnkoJisseki.hacchusakiShashuSbt = indexeddb.getRecord(this.sharyoList, this.viewsData.vwUnkoJisseki.sharyoId).shashuSbt
        this.setYoshaInfo()
      }
    },
    setSeikyuShashuSbt: function () {
      if (this.viewsData.vwUnkoJisseki.haishaKbn === '03') {
        const yoshaShashuSbt = this.viewsData.vwUnkoJisseki.hacchusakiShashuSbt
        this.recHaisoMeisai.seikyuShashuSbt = yoshaShashuSbt
        if (this.viewsData.vwHaisoMeisai && this.viewsData.vwHaisoMeisai.length > 0) {
          this.viewsData.vwHaisoMeisai = this.viewsData.vwHaisoMeisai.map((elem) => {
            elem.seikyuShashuSbt = yoshaShashuSbt
            return elem
          })
          this.viewsData.vwHaisoMeisai.splice()
        }
      }
    },
    onChangeHaishaKbn: function () {
      const self = this
      if (self.viewsData.vwUnkoJisseki.haishaKbn === '02') {
        self.isJishaHaishaMode = true
        self.isJiEigyoshoMode = true
        self.isHokaEigyoshoMode = false
        // this.haishaEigyoshoCd = this.usersEigyosho
        if (!self.recHaisoMeisai.meisaiOrder) {
          self.recHaisoMeisai.juchuEigyoshoId = indexeddb.getRecordByCd(self.currentKaishaCode, self.eigyoshoList, 'eigyoshoCd', self.usersEigyosho, self.baseYmd).id
        }
      } else if (self.viewsData.vwUnkoJisseki.haishaKbn === '03') {
        self.isJishaHaishaMode = false
        self.isJiEigyoshoMode = false
        self.isHokaEigyoshoMode = false
        self.haishaEigyoshoCd = self.usersEigyosho
        if (!self.recHaisoMeisai.meisaiOrder) {
          self.recHaisoMeisai.juchuEigyoshoId = indexeddb.getRecordByCd(self.currentKaishaCode, self.eigyoshoList, 'eigyoshoCd', self.usersEigyosho, self.baseYmd).id
        }
        if (self.initializeDispMode) { return }
        const unkoYmd = self.viewsData.vwUnkoJisseki.unkoYmd
        let tmpHaisoMeisai = Object.assign({}, self.recHaisoMeisai)
        tmpHaisoMeisai = {
          ...tmpHaisoMeisai,
          shiharaiYoteiYmd: [undefined, null, ''].includes(tmpHaisoMeisai.shiharaiYoteiYmd) ? unkoYmd : tmpHaisoMeisai.shiharaiYoteiYmd
        }
        self.recHaisoMeisai = Object.assign({}, tmpHaisoMeisai)
        if (self.viewsData.vwHaisoMeisai && self.viewsData.vwHaisoMeisai.length > 0) {
          // 配送明細の支払予定日を更新
          self.viewsData.vwHaisoMeisai = self.viewsData.vwHaisoMeisai.map((elem) => {
            elem.shiharaiYoteiYmd = [undefined, null, ''].includes(elem.shiharaiYoteiYmd) ? unkoYmd : elem.shiharaiYoteiYmd
            return elem
          })
          self.viewsData.vwHaisoMeisai.splice()
        }
      }
    }
  }
})
